export enum PortalPermissionsEnum {
  AccountsManage = 'fund-portal:accounts:manage-accounts',
}
